import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { getOrderBySessionId } from '../state/actions/order';
import '../styles/success.scss';
import '../styles/service-description.scss';

function PaymentCancel() {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const { sessionOrderLoading } = useSelector((state) => state.order);

  // Fetch order info so the backend knows this session was cancelled
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get('session_id');
    if (sessionId) {
      dispatch(getOrderBySessionId(sessionId));
    }
  }, [dispatch]);

  return (
    <div className="container success-container text-center">
      <h1>{t('payment_cancel_title', 'Betalningen avbröts')}</h1>
      <p>
        {t('payment_cancel_message', 'Din betalning genomfördes inte. Inga pengar har dragits.')}
      </p>
      <button
        className="btn submit-button w-100 mt-4"
        onClick={() => history.push('/success')}
        disabled={sessionOrderLoading}
      >
        {t('payment_cancel_back', 'Gå tillbaka')}
      </button>
    </div>
  );
}

export default PaymentCancel;
